//https://locize.com/blog/react-i18next/

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';


i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  //load translation files automatically
  .use(Backend)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
.init({
  debug: true,
  fallbackLng: 'de',                              // language to use
});

export default i18n;